import React, { Component } from 'react';

import { DatePicker } from 'material-ui-pickers';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import './style.css';

var moment = require('moment');

class SegmentationArgument extends Component {
    date = moment();
    state = {
        id: this.props.argument.index
        ,field: {...this.props.argument.field}
        ,condition: {...this.props.argument.condition}
        ,finalArgument: this.props.argument.finalArgument
        ,fieldType: this.props.argument.fieldType
        ,textTypeValue: ''
        ,numberTypeValue: 0
        ,boolTypeValue: 0
        ,specificDate: this.date
        ,dateField: 'dynamicDate'
        ,dateModifier: 0
        ,periodOptions:[
            {value: 'days', label: 'Dias'},
            {value: 'weeks', label: 'Semanas'},
            {value: 'months', label: 'Meses'},
            {value: 'years', label: 'Anos'},
        ]
        ,dateComparingOptions:[
            {value: 'Y-m-d', label: 'Todos'},
            {value: 'd', label: 'Dia'},
            {value: 'm', label: 'Mês'},
            {value: 'Y', label: 'Ano'},
        ]
        ,dateComparing: ["Y-m-d"]
        ,dateModifierPeriod: 'days'
        ,filterTextField: ''
        ,filterTextCondition: ''
        ,filterTextArgument: ''
        ,filterTextArgumentPeriod: 'Dias'
        ,loading:false
    };

    componentDidMount() {
        if(this.state.field.value){
            const newState = {};
            const thisField = this.props.fields.find(x => x.Field === this.state.field.value);
            const thisCondition = this.state.condition.value && this.props.conditions.find(x => x.Id === this.state.condition.value);
            newState.fieldType = thisField.Type;
            newState.filterTextField = thisField.FieldLabel;
            newState.filterTextCondition = thisCondition.Name;
            newState.filterTextArgument = `'${this.props.argument.finalArgument}'`

            switch(newState.fieldType){
                case 'date':
                    const finalArg = this.props.argument.finalArgument;
                    const dateComparing = finalArg.substring(0, finalArg.indexOf(')')+1);
                    const date = finalArg.substring(finalArg.indexOf(')')+1);
                    const trueDate = moment(date, "YYYY-MM-DD", true);
                    newState.dateComparing = dateComparing === '(Y-m-d)' ? ['Y-m-d'] : dateComparing.replace('(', '').replace(')', '').split('-');

                    if(trueDate.isValid()){
                        newState.dateField = 'specificDate';
                        newState.specificDate = trueDate;
                        newState.filterTextArgument = `'${trueDate.format("DD/MM/YYYY")}'`;
                    }else{
                        if(date){
                            const arg = date.split(" ");
                            const parsedValue = parseInt(arg[0]);
                            const value = parsedValue > 0 ? ` +${parsedValue}` : parsedValue < 0 ? ` ${parsedValue}` : '';
                            const period = this.state.periodOptions.find(x => x.value === arg[1]).label;

                            newState.dateModifier = parsedValue;
                            newState.dateModifierPeriod = arg[1];
                            newState.filterTextArgumentPeriod = parsedValue !== 0 ? ` ${period}` : ''

                            newState.filterTextArgument = `Hoje${value}${newState.filterTextArgumentPeriod}`;
                        } else {
                            newState.filterTextArgument = 'Hoje';
                        }
                    }
                    break;
                case 'number':
                    newState.numberTypeValue = this.props.argument.finalArgument;
                    break;
                case 'bool':
                    newState.boolTypeValue = this.props.argument.finalArgument;
                    break;
                case 'text':
                default:
                    newState.textTypeValue = this.props.argument.finalArgument;
                    break;
            }
            this.setState(newState);
        }
    }

    componentDidUpdate(prevProps, prevState){
        const { filterTextField, filterTextCondition, filterTextArgument, id, field, fieldType, condition, finalArgument, dateComparing, dateField, dateModifier } = this.state;
        if(prevState.finalArgument !== finalArgument || prevState.filterTextField !== filterTextField || prevState.filterTextCondition !== filterTextCondition || prevState.filterTextArgument !== filterTextArgument){
            let arg = finalArgument;
            if(fieldType === 'date' && arg.indexOf(")") < 0){
                if(dateField === 'dynamicDate' && dateModifier === 0){
                    arg = `(${dateComparing.join("-")})`;
                }else{
                    arg = `(${dateComparing.join("-")})${finalArgument}`;
                }
            }
            const argument = { index:id, field, fieldType, condition, finalArgument: arg };
            this.props.updateArgument(argument, `${filterTextField} ${filterTextCondition} ${filterTextArgument}`);
        }
    }

    handleDeleteArgument = () => {
        if(window.confirm("Delete this argument?")){
            this.props.handleDeleteArgument(this.props.argument.index);
        }
    }

    handleSpecificDateChange = (value) => {
        const finalDate = moment(value).format("YYYY-MM-DD");
        this.setState({ 
            specificDate: finalDate, 
            finalArgument: finalDate, 
            filterTextArgument: `'${moment(value).format("DD/MM/YYYY")}'` 
        });
    }

    handleDateTypeRadioChange = (e) => {
        const value = e.target.value;
        const newState = {dateField: value};

        if(value === "specificDate"){
            const specificDate = moment(this.state.specificDate);
            newState.finalArgument = specificDate.format("YYYY-MM-DD");
            newState.filterTextArgument = specificDate.format("DD/MM/YYYY");
        }else{
            const parsedValue = parseInt(this.state.dateModifier);
            const value = parsedValue > 0 ? ` +${parsedValue}` : parsedValue < 0 ? ` ${parsedValue}` : '';
            const period = parsedValue !== 0 ? ` ${this.state.filterTextArgumentPeriod}` : '';

            newState.finalArgument = `(${this.state.dateComparing.join("-")})${this.state.dateModifier} ${this.state.dateModifierPeriod}`;
            newState.filterTextArgument = `Hoje${value}${period}`;
        }

        this.setState(newState)
    };
    
    handleArgumentFieldChange = (e, el) => {
        const newField = {...this.state.field};
        const newCondition = {...this.state.field};
        const fieldType = el.props["data-type"];
        newCondition.value = '';
        newField.value = e.target.value;
        newField.type = fieldType;
        const newState = {
            fieldType,
            field: newField,
            condition: newCondition,
            conditionValue: '',
            filterTextCondition: '',
            filterTextArgument: '',
            filterTextField: el.props.children
        };

        if(fieldType === "date"){
            newState.filterArgument = `()`;
        }

        this.setState(newState);
    }
    
    handleArgumentConditionChange = (e, el) => {
        const newCondition = {...this.state.condition};
        newCondition.value = e.target.value;

        const newState = {
            condition: newCondition,
            conditionValue: el.props["data-type"],
            filterTextCondition: el.props.children
        };

        if(this.state.fieldType === "date"){
            newState.filterTextArgument = `(${this.state.dateComparing.join("-")})Hoje`;
        }

        this.setState(newState);
    }

    handleArgumentDateComparingChange = (e, item) => {
        let value = e.target.value;
        let arg = this.state.finalArgument;

        arg = arg.replace(`(${this.state.dateComparing.join("-")})`, '');

        if(item.props.value==="Y-m-d"){
            value = ["Y-m-d"];
        }else{
            if (value.length > 1 && value.indexOf("Y-m-d") > -1){
                value.splice(value.indexOf("Y-m-d"), 1);
            }

            if(!value.length){
                value = ["Y-m-d"];
            }
        }
        value.sort().reverse();

        this.setState({ dateComparing: value, finalArgument: `(${value.join("-")})${arg}` });
    }

    handleDateModifierChange = (e) => {
        const parsedValue = parseInt(e.target.value);
        const value = parsedValue > 0 ? ` +${parsedValue}` : parsedValue < 0 ? ` ${parsedValue}` : '';
        const period = parsedValue !== 0 ? ` ${this.state.filterTextArgumentPeriod}` : '';
        this.setState({ [e.target.id]: parsedValue, filterTextArgument: `Hoje${value}${period}`, finalArgument: `${e.target.value} ${this.state.dateModifierPeriod}` })
    };
    handleArgumentPeriodChange = (e, el) => {
        let filterTextArgument = this.state.filterTextArgument.replace(this.state.filterTextArgumentPeriod, '');

        if(this.state.dateModifier !== 0){
            filterTextArgument += el.props.children;
        }

        this.setState({
            dateModifierPeriod: e.target.value,
            filterTextArgumentPeriod: el.props.children,
            filterTextArgument,
            finalArgument: `${this.state.dateModifier} ${e.target.value}`
        });
    }
    handleArgumentTextChange = (e) => {
        this.setState({ [e.target.id]: e.target.value, filterTextArgument: `'${e.target.value}'`, finalArgument: e.target.value });
    }
    handleArgumentNumberChange = (e) => {
        this.setState({ [e.target.id]: e.target.value, filterTextArgument: `'${e.target.value}'`, finalArgument: e.target.value });
    }
    handleArgumentBoolChange = (e, el) => {
        this.setState({ filterTextArgument: el.props.children, finalArgument: e.target.value });
    }

    renderFieldOptions = (e) => {
        const fields = this.props.fields;
        if(fields===null)
            return;

        const items = [<option value="" key="0" disabled={true}>Escolha um campo</option>];
        for (let i=0,n=fields.length;i<n;i++) {
            items.push(<option 
                        key={fields[i].Field} 
                        data-type={fields[i].Type}
                        disabled={!fields[i].Type}
                        value={fields[i].Field}>{fields[i].FieldLabel}</option>);
        }
        return items;
    }

    renderConditionsOptions = (e) => {
        const conditions = this.props.conditions;
        if(conditions===null)
            return;

        const items = [<option value="" key="0" disabled={true}>Escolha uma condição</option>];
        for (let i=0,n=conditions.length;i<n;i++) {
            const conditionTypes = conditions[i].Type.split(',');
            if(conditionTypes.includes(this.state.fieldType)){
                items.push(<option 
                            key={conditions[i].Id} 
                            value={conditions[i].Id}>{conditions[i].Name}</option>);
            }
        }
        return items;
    }

    renderDateComparingOptions = (e) => {
        const dateComparing = this.state.dateComparingOptions;
        if(dateComparing===null)
            return;

        const items = [<option value="" key="default" disabled={true}>Escolha a combinação</option>];
        for (let i=0,n=dateComparing.length;i<n;i++) {
            items.push(<option 
                        key={i} 
                        value={dateComparing[i].value}>{dateComparing[i].label}</option>);
        }
        return items;
    }

    renderPeriodOptions = (e) => {
        const periods = this.state.periodOptions;
        if(periods===null)
            return;

        const items = [<option value="" key="0" disabled={true}>Escolha um Período</option>];
        for (let i=0,n=periods.length;i<n;i++) {
            items.push(<option 
                        key={i} 
                        value={periods[i].value}>{periods[i].label}</option>);
        }
        return items;
    }

    render() {
        const { argument } = this.props;
        const { 
            editable, 
            field, 
            condition, 
            fieldType, 
            dateField, 
        } = this.state;

        const optsFields = this.renderFieldOptions()
              , optsConditions = this.renderConditionsOptions()
              , optsPeriods = this.renderPeriodOptions()
              , optsDateComparing = this.renderDateComparingOptions()
              , conditionsClass = fieldType === 'date' ? 'col-md-3' : 'col-md-6';

        return (
            <FormControl key={argument.index} component="fieldset">
                <FormLabel component="legend">
                    <span className="argNumber">Argumento {argument.index}</span>&nbsp; {argument.groupId !== 0 && `- Grupo: ${argument.groupId}`}
                </FormLabel>
                <button type="button" onClick={this.handleDeleteArgument} className="actionButton danger deleteArgument"><i className="fa fa-times"></i></button>
                <div className="row">
                    {
                        optsFields && optsFields.length &&
                        <div className="col-12 col-md-6 fieldHolder required selectField ">
                            <FormControl fullWidth={true}>
                                <InputLabel htmlFor={field.id}>Campo</InputLabel>
                                <Select id={field.id}
                                        name={field.id}
                                        value={field.value}
                                        onChange={this.handleArgumentFieldChange}
                                        data-empty-error-message="Este campo não pode estar vazio">
                                {optsFields}
                                </Select>
                            </FormControl>
                        </div>
                    }
                    {
                        optsConditions && optsConditions.length &&
                        <div className={"col-12 fieldHolder required selectField smallGutter-right " + conditionsClass}>
                            <FormControl fullWidth={true}>
                                <InputLabel htmlFor={condition.id}>Condição</InputLabel>
                                <Select id={condition.id}
                                        name={condition.id}
                                        value={condition.value}
                                        onChange={this.handleArgumentConditionChange}
                                        disabled={!field.value}
                                        data-empty-error-message="Este campo não pode estar vazio">
                                {optsConditions}
                                </Select>
                            </FormControl>
                        </div>
                    }
                    {
                        fieldType === 'date' &&
                        <div className="col-12 col-md-3 fieldHolder required selectField smallGutter-left">
                            <FormControl fullWidth={true}>
                                <InputLabel htmlFor="dateComparing">Comparação</InputLabel>
                                <Select id="dateComparing"
                                        name="dateComparing"
                                        value={this.state.dateComparing}
                                        onChange={this.handleArgumentDateComparingChange}
                                        disabled={!field.value}
                                        multiple
                                        data-empty-error-message="Este campo não pode estar vazio">
                                    {optsDateComparing}
                                </Select>
                            </FormControl>
                        </div>
                    }
                </div>
                {
                    field.value && condition.value &&
                    <div className="row">
                        {
                            fieldType === "boolean" &&
                            <div className="col-12 fieldHolder selectField">
                                <FormControl fullWidth={true}>
                                    <InputLabel htmlFor={condition.id}>Sim / Não</InputLabel>
                                    <Select id="boolTypeValue"
                                            name="boolTypeValue"
                                            value={this.state.boolTypeValue}
                                            onChange={this.handleArgumentBoolChange}>
                                    <option value="" key="0" disabled={true}>Escolha uma opção</option>
                                    <option value="1" key="1">Sim</option>
                                    <option value="0" key="2">Não</option>
                                    </Select>
                                </FormControl>
                            </div>
                        }
                        {
                            fieldType === "text" &&
                            <div className="col-12">
                                <div className="fieldHolder">
                                    <TextField fullWidth
                                            id="textTypeValue"
                                            name="textTypeValue"
                                            value={this.state.textTypeValue}
                                            onChange={this.handleArgumentTextChange}
                                            label="Argumento"
                                            placeholder="Introduza o Argumento" />
                                </div>
                            </div>
                        }
                        {
                            fieldType === "number" &&
                            <div className="col-12">
                                <div className="fieldHolder">
                                    <TextField fullWidth
                                            id="numberTypeValue"
                                            name="numberTypeValue"
                                            type="number"
                                            value={this.state.numberTypeValue}
                                            onChange={this.handleArgumentNumberChange}
                                            label="Argumento"
                                            placeholder="Introduza o Argumento" />
                                </div>
                            </div>
                        }
                        {
                            fieldType === "date" &&
                            <div className="col-12">
                                <RadioGroup
                                    className="radioButtonHolder"
                                    name="dateField"
                                    value={dateField}
                                    disabled={!editable}
                                    onChange={this.handleDateTypeRadioChange}>
                                    <FormControlLabel
                                        className="radioButton"
                                        value="dynamicDate"
                                        label="Data Dinâmica"
                                        control={<Radio />} />
                                    <FormControlLabel
                                        className="radioButton"
                                        value="specificDate"
                                        label="Data Específica"
                                        control={<Radio />} />
                                </RadioGroup>
                                <div className="row">
                                    <div className="col-md-6 required">
                                        <FormControl component="fieldset" className="dynamicDateHolder" disabled={dateField === 'specificDate'}>
                                            {/* <FormLabel component="legend">Hoje&nbsp;<span className="smallText">({moment().format('DD/MM')})</span></FormLabel> */}
                                            <FormLabel component="legend">Hoje</FormLabel>
                                            <TextField 
                                                    id="dateModifier"
                                                    name="dateModifier"
                                                    type="number"
                                                    label="Número"
                                                    value={this.state.dateModifier}
                                                    disabled={dateField === 'specificDate'}
                                                    onChange={this.handleDateModifierChange} />
                                            <FormControl>
                                                <InputLabel htmlFor={condition.id}>Período</InputLabel>
                                                <Select id="dateModifierPeriod"
                                                        name="dateModifierPeriod"
                                                        value={this.state.dateModifierPeriod}
                                                        disabled={dateField === 'specificDate'}
                                                        onChange={this.handleArgumentPeriodChange}>
                                                    {optsPeriods}
                                                </Select>
                                            </FormControl>
                                        </FormControl>
                                    </div>
                                    <div className="col-md-6 specificDateHolder">
                                        <DatePicker
                                            fullWidth
                                            name="specificDate"
                                            label="Data Específica"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha a data"
                                            value={this.state.specificDate || null}
                                            disabled={dateField === 'dynamicDate'}
                                            locale="pt-PT"
                                            onChange={this.handleSpecificDateChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </FormControl>
        );
    }
}

export default SegmentationArgument;
